import { RefObject } from "react";
import axios from "axios";
import { MenuItem } from "@mui/material";
import { State } from "@progress/kendo-data-query";
import {
  faBook,
  faClipboard,
  faList,
  faObjectUngroup,
  faRoute,
} from "@fortawesome/free-solid-svg-icons";
import { ToolbarDropdownMenu } from "../../../Grid/Toolbar/ToolbarDropdownMenu";
import ExcelExportButton from "../../../Grid/ExcelExport/ExcelExportButton";
import { UppercaseButton } from "../../../Layout/Buttons/UppercaseButton";
import { KENDO_BUTTON_CLASSES } from "../../../Layout/Buttons/KendoButtons";
import { combinedUrls } from "../../../URL/functions";
import { ttProtectionUrls } from "../../../URL/ApplicationUrls";
import { IconWithRightMargin } from "../../../Layout/Icons/IconWithRightMargin";
import { useExportWithToast } from "../../../Grid/ExcelExport/useExportWithToast";
import RenderAuthorized from "../../../Auth/RenderAuthorized";
import { AuthorizationPolicies } from "../../../Auth/AuthorizationPolicy";

export const TTProtectionOverviewToolbarMenu = (url: string) =>
  function TtProtectionExportMenu(dataState: State, { current }: RefObject<any>) {
    const exportTransitTimeFeed = useExportWithToast(
      () =>
        axios.get(combinedUrls(ttProtectionUrls.base.apiUrl, "TransitTime"), {
          responseType: "blob",
        }),
      "Exporting LLP TT Feed"
    );

    const exportR360DataFeed1 = useExportWithToast(
      () =>
        axios.get(combinedUrls(ttProtectionUrls.base.apiUrl, "R360DataFeed1"), {
          responseType: "blob",
        }),
      "Exporting R360 data feed 1"
    );

    const exportR360DataFeed2 = useExportWithToast(
      () =>
        axios.get(combinedUrls(ttProtectionUrls.base.apiUrl, "CarrierLanesReport"), {
          responseType: "blob",
        }),
      "Exporting R360 data feed 2"
    );

    const exportEverstreamAssetUpload = useExportWithToast(
      () =>
        axios.get(combinedUrls(ttProtectionUrls.base.apiUrl, "EverstreamAssetUpload"), {
          responseType: "blob",
        }),
      "Exporting Everstream Asset Upload"
    );

    const exportEverstreamLaneUpload = useExportWithToast(
      () =>
        axios.get(combinedUrls(ttProtectionUrls.base.apiUrl, "EverstreamLaneUpload"), {
          responseType: "blob",
        }),
      "Exporting Everstream Lane Upload"
    );

    return (
      <RenderAuthorized requiredRoles={AuthorizationPolicies.RequireAdminReadOnlyNetworkRiskLaunch}>
        <ToolbarDropdownMenu text="Exports" key="tt-protection-export-menu">
          <MenuItem>
            <ExcelExportButton
              url={url}
              dataState={dataState}
              columns={current?.columns.slice(0)}
              fileName="TTProtections"
            />
          </MenuItem>
          <MenuItem>
            <UppercaseButton
              className={KENDO_BUTTON_CLASSES}
              onClick={() => exportTransitTimeFeed()}
            >
              <IconWithRightMargin icon={faClipboard} />
              Export LLP TT Feed
            </UppercaseButton>
          </MenuItem>
          <MenuItem>
            <UppercaseButton className={KENDO_BUTTON_CLASSES} onClick={() => exportR360DataFeed1()}>
              <IconWithRightMargin icon={faBook} />
              Export R360 Data Feed 1
            </UppercaseButton>
          </MenuItem>
          <MenuItem>
            <UppercaseButton className={KENDO_BUTTON_CLASSES} onClick={() => exportR360DataFeed2()}>
              <IconWithRightMargin icon={faObjectUngroup} />
              Export R360 Data Feed 2
            </UppercaseButton>
          </MenuItem>
          <MenuItem>
            <UppercaseButton
              className={KENDO_BUTTON_CLASSES}
              onClick={() => exportEverstreamAssetUpload()}
            >
              <IconWithRightMargin icon={faList} />
              Everstream Asset Upload
            </UppercaseButton>
          </MenuItem>
          <MenuItem>
            <UppercaseButton
              className={KENDO_BUTTON_CLASSES}
              onClick={() => exportEverstreamLaneUpload()}
            >
              <IconWithRightMargin icon={faRoute} />
              Everstream Lane Upload
            </UppercaseButton>
          </MenuItem>
        </ToolbarDropdownMenu>
      </RenderAuthorized>
    );
  };
